import { Route, RouterModule } from '@angular/router';
import { dockManagement } from './dock-management.component';
import { UserAuthGuardService } from '../../services/user-auth-guard.service';

export const dock_management_ROUTES: Route[] = [
	{
		path: 'details',
		component: dockManagement,
	}
];
	
export const dockManagementRoutes = RouterModule.forChild(dock_management_ROUTES);


// WEBPACK FOOTER //
// ./src/app/component/dock-management/dock-management.routes.ts